import * as React from 'react';

import { useContractContext, useStrings } from 'src/providers';
import { useCurrencyFormatter } from 'src/hooks/useCurrencyFormatter';

import { StyledHorizontalPrompt, StyledHorizontalOption } from './StyledHorizontal';
import { Header, HeaderPromptTypes } from '../Header';
import { Footer } from '../Footer';
import { FormattedString } from 'src/components/Shared/FormattedString';

import { IContract } from 'src/types/IContract';
import { ContractDetailsRequestedPromptOptions } from 'src/types/IModal';
import { OptionInputStyles, OptionInputTypes } from 'src/types/IOptions';

interface IHorizontalPromptProps {
  contractDetailsRequested: (prompt: ContractDetailsRequestedPromptOptions) => void;
}

export function HorizontalPrompt({ contractDetailsRequested }: IHorizontalPromptProps) {
  const formatCurrency = useCurrencyFormatter();

  const {
    contracts,
    selectedContractId,
    toggleContract,
  } = useContractContext();
  const { headline, termLabel } = useStrings();

  const renderContractOption = React.useCallback((contract: IContract) => {
    const { id, price, termLabelSingular } = contract;
    const formattedPrice = formatCurrency(+price);

    return (
      <StyledHorizontalOption
        key={id}
        contractId={id}
        inputStyle={OptionInputStyles.HIDDEN}
        inputType={OptionInputTypes.CHECKBOX}
        isSelected={selectedContractId === id}
        onChange={toggleContract}
      >
        <FormattedString
          className="text"
          string={termLabel}
          tagName="span"
          values={{ termSingular: termLabelSingular }}
        />
        <span className='price'>{formattedPrice}</span>
      </StyledHorizontalOption>
    );
  }, [selectedContractId, toggleContract, formatCurrency]);

  return (
    <StyledHorizontalPrompt data-test="product-page-select">
      <Header promptType={HeaderPromptTypes.SELECT}>
        <span>{headline}</span>
      </Header>

      <ul className="contracts" data-test='pdp-contracts-select'>
        {contracts.map(renderContractOption)}
      </ul>

      <Footer contractDetailsRequested={contractDetailsRequested} />
    </StyledHorizontalPrompt>
  );
}
